const defaultState = { isFetching: true, list: [] };

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'IS_FETCHING_ZIP':
      return {
        ...state,
        isFetching: false,
      };

    case 'ZIP_LIST':
      return {
        ...state,
        list: action.payload,
      };

    default:
      return state;
  }
};
